/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Members_TabInputs */



/**
* | output |
* | --- |
* | "Members" |
*
* @param {Team_Manager_Members_TabInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_members_tab = /** @type {((inputs?: Team_Manager_Members_TabInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Members_TabInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Membres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder")
	if (locale === "it") return /** @type {LocalizedString} */ ("Membri")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Участники")
	if (locale === "es") return /** @type {LocalizedString} */ ("Miembros")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成员")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メンバー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सदस्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Membros")
	return /** @type {LocalizedString} */ ("Members")
});